import { createContext, useCallback, useContext, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "../ui/dialog";
import { BusinessEnquiryForm } from "../forms/BusinessEnquiryForm";

const EnquiryContext = createContext({ openEnquiry: () => {} });

export const EnquiryProvider = ({ children }) => {
  const [state, setState] = useState({ open: false, category: "", nonce: 0 });
  const openEnquiry = useCallback(
    (category = "") => setState((s) => ({ open: true, category, nonce: s.nonce + 1 })),
    []
  );

  return (
    <EnquiryContext.Provider value={{ openEnquiry }}>
      {children}
      <Dialog open={state.open} onOpenChange={(open) => setState((s) => ({ ...s, open }))}>
        <DialogContent className="max-h-[92vh] max-w-3xl overflow-y-auto rounded-lg p-0 sm:rounded-lg" data-testid="enquiry-modal">
          <div className="border-b border-slate-200 bg-[#F4F6F8] px-6 py-6 sm:px-10">
            <p className="eyebrow">Business request</p>
            <DialogTitle className="mt-3 font-display text-2xl font-semibold tracking-tight text-[#0B1220]">
              Request an Expert
            </DialogTitle>
            <DialogDescription className="mt-2 text-sm text-slate-500">
              Tell us about your requirement. Information you share is treated confidentially and used only to assess your request.
            </DialogDescription>
          </div>
          <div className="px-6 py-8 sm:px-10">
            <BusinessEnquiryForm key={state.nonce} defaultCategory={state.category} idPrefix="modal" />
          </div>
        </DialogContent>
      </Dialog>
    </EnquiryContext.Provider>
  );
};

export const useEnquiry = () => useContext(EnquiryContext);
